<template>
  <div>
    <el-dialog
      :title="editType == 'edit' ? '编辑会员商品' : '新增会员商品'"
      :visible.sync="value"
      append-to-body
      :width="`${900}px`"
      top="80px"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :model="formChild"
        label-width="120px"
        size="small"
        style="padding: 15px;"
        :rules="rules"
      >
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="_title">
                商品基础配置

                <el-tooltip placement="top">
                  <div slot="content">
                    <ul>
                      <li>会员类型：选择商品的的会员类型，保存后不可更改</li>
                      <li>
                        商品类型：区分商品是在客户端上的，还是做活动用的，保存后不可更改
                      </li>
                      <li>商品编号：配置时手动填写，保存后不可更改</li>
                      <li>
                        商品名称：配置时手动填写，同一会员类型商品名称不可重复，保存后不可更改
                      </li>
                    </ul>
                  </div>
                  <i class="header-icon el-icon-info"></i>
                </el-tooltip>
              </div>
            </template>
            <div class="_box">
              <el-form-item
                label="会员类型"
                prop="memberTypeId"
              >
                <el-select
                  v-model="formChild.memberTypeId"
                  placeholder="请选择会员类型"
                  class="_width_214"
                  :disabled="editType == 'edit'"
                  @change="changeMemberTypeId(formChild.memberTypeId)"
                >
                  <el-option
                    v-for="item in bizCode.member_type"
                    :key="item.dictKey"
                    :label="`${item.dictValue} (${item.dictKey})`"
                    :value="+item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="商品类型"
                prop="goodsType"
              >
                <el-radio-group
                  v-model="formChild.goodsType"
                  :disabled="editType == 'edit'"
                  @change="changeGoodsType(formChild.goodsType)"
                >
                  <el-radio
                    v-for="item in bizCode.goods_type"
                    :key="item.dictKey"
                    :label="item.dictKey"
                  >{{ item.dictValue }}</el-radio>
                  <!-- <el-radio label="2">活动商品</el-radio> -->
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="商品编号"
                prop="goodsCode"
              >
                <el-input
                  v-model="formChild.goodsCode"
                  placeholder="请输入会员商品编号"
                  maxlength="99"
                  witch="214"
                  class="_width_370"
                  :disabled="editType == 'edit'"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="商品名称"
                prop="goodsName"
              >
                <el-input
                  v-model="formChild.goodsName"
                  placeholder="请输入会员商品名称"
                  maxlength="99"
                  class="_width_370"
                  :disabled="editType == 'edit'"
                ></el-input>
              </el-form-item>

              <!-- - 首次编辑保存后，再次进入页面，不可编辑上述四个字段 -->
              <!-- - 后续活动商品类型可能有关联的字段 -->
              <el-form-item
                label="销售场景"
                v-if="formChild.goodsType == 2"
              >
                <el-select
                  v-model="formChild.activityType"
                  placeholder="请选择销售场景"
                  :disabled="false"
                  class="_width_214"
                >
                  <el-option
                    v-for="item in bizCode.member_goods_activity_type"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="活动ID"
                v-if="formChild.goodsType == 2"
              >
                <el-input
                  v-model="formChild.activityId"
                  placeholder="请输入活动ID,非活动不填"
                  class="_width_370"
                  maxlength="999"
                ></el-input>
              </el-form-item>
            </div>
          </el-collapse-item>

          <el-collapse-item name="2">
            <template slot="title">
              <div class="_title">
                商品展示配置
                <el-tooltip placement="top">
                  <div slot="content">
                    <ul>
                      <li>限制购买次数：若配置 1 次，则购买后商品下架</li>
                      <li>
                        销售端类型：代表商品可在哪些端卖，可添加的端为上面所选的会员类型携带，所选的端代表该端下的对应的所有渠道
                      </li>
                      <li>
                        前端可见：代表该商品是否可在客户端呈现，例如活动商品配置为不可见状态。
                      </li>
                      <li>
                        显示顺序：通过输入数值来排序，若数值相同，则按照创建时间排序
                      </li>
                      <li>
                        可见人群：决定该商品对哪些人群可见；未登录用户仅在「全部用户」、或用户类型勾选了「游客」时可见
                      </li>
                      <li>
                        指定用户：名单为一次性快照，需要变更时请重新上传覆盖
                      </li>
                    </ul>
                  </div>
                  <i class="header-icon el-icon-info"></i>
                </el-tooltip>
              </div>
            </template>
            <div class="_box">
              <el-form-item
                label="销售端类型"
                prop="key7"
              >
                <el-button
                  type="primary"
                  plain
                  @click="addTypeItem"
                >添加销售端</el-button>

                <div
                  v-for="(item, index) in formChild.saleChannelList"
                  :key="index"
                >
                  <div style="margin-top: 15px;">
                    <el-select
                      v-model="item.clientType"
                      placeholder="请选择客户端"
                      class="_width_214"
                      v-loading="client_types_loading"
                      :disabled="!formChild.memberTypeId"
                    >
                      <el-option
                        v-for="item in bizCode.client_types"
                        :key="item.dictKey"
                        :disabled="cleanUpDuplicates(item.dictKey)"
                        :label="item.dictValue"
                        :value="item.dictKey"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="item.channelType"
                      placeholder="请选择渠道"
                      style="margin: 0 25px;"
                      class="_width_214"
                    >
                      <el-option
                        v-for="item in bizCode.channel_type"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                      ></el-option>
                    </el-select>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #ff0000;"
                      @click="
                      formChild.saleChannelList = formChild.saleChannelList.filter(
                        i => i !== item
                      )
                      "
                    >删除</el-button>
                  </div>

                  <div
                    style="margin: 15px 0 15px -120px;"
                    v-if="item.channelType != 1 && item.channelType"
                  >
                    <el-form-item
                      prop="appidFilterNames"
                      label="指定渠道"
                    >
                      <el-input
                        type="textarea"
                        rows="3"
                        @focus="handleClick(index)"
                        v-model="item.channelNames"
                      >
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>

              <el-form-item
                label="前端可见"
                prop="frontVisible"
              >
                <el-radio-group v-model="formChild.frontVisible">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="显示顺序"
                prop="displayOrder"
              >
                <el-input
                  v-model="formChild.displayOrder"
                  maxlength="9999"
                  placeholder="请输入显示顺序"
                  class="_width_370"
                  @keypress.native="onKeyPress"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="可见人群"
                prop="visibleType"
              >
                <el-radio-group v-model="formChild.visibleType">
                  <el-radio
                    v-for="item in visibleTypeOptions"
                    :key="item.value"
                    :label="item.value"
                  >{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item
                v-if="formChild.visibleType === visibleTypeEnum.USER_TAG"
                label="用户标签"
                prop="visibleUserTags"
              >
                <el-select
                  v-model="formChild.visibleUserTags"
                  placeholder="请选择用户标签"
                  class="_width_370"
                  multiple
                  filterable
                  collapse-tags
                >
                  <el-option
                    v-for="item in bizCode.label_user_tag"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                v-if="formChild.visibleType === visibleTypeEnum.USER_TYPE"
                label="用户类型"
                prop="visibleUserTypes"
              >
                <el-select
                  v-model="formChild.visibleUserTypes"
                  placeholder="请选择用户类型"
                  class="_width_370"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in visibleUserTypeOptions"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                v-if="formChild.visibleType === visibleTypeEnum.PHONE_LIST"
                label="指定用户"
                prop="visiblePhoneCount"
              >
                <div class="visible_phone_actions">
                  <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="downloadVisiblePhoneTemplate"
                  >下载模板</el-button>

                  <el-upload
                    class="visible_phone_upload"
                    action=""
                    :show-file-list="false"
                    :multiple="false"
                    :before-upload="beforeVisiblePhoneUpload"
                    :http-request="importVisiblePhone"
                  >
                    <el-button
                      type="primary"
                      size="small"
                      :loading="visiblePhoneUploading"
                    >上传名单</el-button>
                  </el-upload>

                  <template v-if="formChild.visiblePhoneCount > 0">
                    <el-button
                      type="text"
                      size="small"
                      @click="downloadVisiblePhone"
                    >下载已导入名单</el-button>
                    <el-button
                      type="text"
                      size="small"
                      style="color: #ff0000;"
                      @click="clearVisiblePhone"
                    >清空重传</el-button>
                  </template>
                </div>

                <div class="visible_phone_tip">
                  <span v-if="formChild.visiblePhoneCount > 0">已导入 {{ formChild.visiblePhoneCount }} 条</span>
                  <span v-else>请上传手机号名单，仅支持 xlsx/xls，单次最多 {{ visiblePhoneMaxCount }} 条</span>
                </div>

                <div
                  v-if="visiblePhoneImportResult"
                  class="visible_phone_result"
                >
                  <div>
                    本次上传 {{ visiblePhoneImportResult.totalRows }} 行，合法 {{ visiblePhoneImportResult.validRows }} 行，去重后 {{ visiblePhoneImportResult.distinctCount }} 条
                  </div>
                  <div
                    v-if="visiblePhoneImportResult.invalidRowText"
                    class="visible_phone_invalid"
                  >
                    非法行号：{{ visiblePhoneImportResult.invalidRowText }}
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-collapse-item>

          <el-collapse-item name="3">
            <template slot="title">
              <div class="_title">
                商品定价配置
                <el-tooltip placement="top">
                  <div slot="content">
                    <ul>
                      <li>限制购买次数：若配置 1 次，则购买后商品下架</li>
                    </ul>
                  </div>
                  <i class="header-icon el-icon-info"></i>
                </el-tooltip>
              </div>
            </template>
            <div class="_box">
              <el-form-item
                v-if="isShowAutoRenewFlag"
                label="自动续费商品"
                prop="autoRenewFlag"
              >
                <el-radio-group
                  v-model="formChild.autoRenewFlag"
                  :disabled="editType == 'edit'"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>

              <div v-if="formChild.autoRenewFlag == '0'">
                <el-form-item
                  label="定价周期"
                  prop="salePeriod"
                >
                  <div>
                    <el-input
                      v-model="formChild.salePeriod"
                      @input="getPresentPrice"
                      placeholder="请输入数字"
                      maxlength="99"
                      class="_width_214"
                      @keypress.native="onKeyPress"
                      :disabled="editType == 'edit'"
                    >
                    </el-input>
                  </div>

                  <el-select
                    v-model="formChild.salePeriodUnit"
                    @change="getPresentPrice"
                    placeholder="请选择周期"
                    class="_width_214"
                    :disabled="editType == 'edit'"
                    style="margin-top: 15px;"
                  >
                    <el-option
                      v-for="item in bizCode.sale_period_unit"
                      :key="item.dictKey"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="售价"
                  prop="salePrice"
                >
                  <div style="display: flex;">
                    <el-input
                      v-model.trim="formChild.salePrice"
                      @input=getPresentPrice
                      maxlength="99"
                      class="_width_214"
                      placeholder="请输入售价"
                      @keypress.native="formatInput"
                    ></el-input>
                    <span
                      v-if="formChild.memberTypeKey == 5"
                      style="padding-left: 5px;"
                    > 元/台</span>
                    <span
                      v-else
                      style="padding-left: 5px;"
                    > 元</span>
                  </div>
                </el-form-item>

                <el-form-item
                  label="限制购买次数"
                  prop="limitPurchaseTimesFlag"
                >
                  <el-radio-group v-model="formChild.limitPurchaseTimesFlag">
                    <el-radio label="0">不限制</el-radio>
                    <el-radio label="1">1次</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div v-else>
                <!-- 自动续费会员商品的支付方式 -->
                <el-form-item
                  label="支付方式"
                  prop="autoRenewPayType"
                >
                  <el-checkbox-group v-model="formChild.autoRenewPayType">
                    <el-checkbox label="1">微信支付</el-checkbox>
                    <el-checkbox label="2">支付宝支付</el-checkbox>
                    <el-checkbox label="5">IOS支付</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>

                <el-form-item
                  label="微信模板ID"
                  prop="wechatTemplateId"
                  v-if="
                  Array.isArray(formChild.autoRenewPayType) &&
                  formChild.autoRenewPayType.includes('1')
                "
                >
                  <el-input
                    v-model.trim="formChild.wechatTemplateId"
                    placeholder="请输入微信模板ID"
                    class="_width_214"
                    maxlength="999"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="定价周期"
                  prop="salePeriod"
                >
                  <div>
                    <el-input
                      v-model="formChild.salePeriod"
                      placeholder="请输入数字"
                      maxlength="99"
                      class="_width_214"
                      :disabled="editType == 'edit'"
                      @keypress.native="onKeyPress"
                    ></el-input>
                  </div>

                  <el-select
                    v-model="formChild.salePeriodUnit"
                    placeholder="请选择周期"
                    class="_width_214"
                    :disabled="editType == 'edit'"
                    style="margin-top: 15px;"
                  >
                    <el-option
                      v-for="item in bizCode.sale_period_unit"
                      :key="item.dictKey"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="首次续费"
                  prop="firstRenewPrice"
                >
                  <div style="display: flex;">
                    <el-input
                      v-model.trim="formChild.firstRenewPrice"
                      class="_width_214"
                      maxlength="99"
                      placeholder="请输入数字"
                      @keypress.native="formatInput"
                    ></el-input>
                    <span style="padding-left: 5px;"> 元</span>
                  </div>
                </el-form-item>
                <el-form-item
                  label="后续续费"
                  prop="followRenewPrice"
                >
                  <div style="display: flex;">
                    <el-input
                      v-model.trim="formChild.followRenewPrice"
                      class="_width_214"
                      maxlength="99"
                      placeholder="请输入数字"
                      @keypress.native="formatInput"
                    ></el-input>
                    <span style="padding-left: 5px;"> 元</span>
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item name="4">
            <template slot="title">
              <div class="_title">
                商品折扣配置
                <el-tooltip placement="top">
                  <div slot="content">
                    <ul>
                      <li>标签折扣：通过选择不同类型的用户，设置不同的价格</li>
                    </ul>
                  </div>
                  <i class="header-icon el-icon-info"></i>
                </el-tooltip>
              </div>
            </template>
            <div class="_box">
              <!-- //  - 自动续费商品，不支持折扣配置 -->
              <el-form-item label="设置折扣">
                <el-switch
                  v-model="formChild.discountFlag"
                  active-value="1"
                  inactive-value="0"
                  :disabled="formChild.autoRenewFlag == '1'"
                ></el-switch>
              </el-form-item>

              <el-form-item
                label="折扣类型"
                v-if="formChild.discountFlag == '1'"
                prop="discountType"
              >
              <el-radio-group v-model="formChild.discountType">
                <template v-for="item in bizCode.discount_type">
                  <!-- 企业会员只显示基础折扣（dictKey为4），其他会员只显示标签折扣（dictKey为1） -->
                  <el-radio
                    v-if="formChild.memberTypeKey == 5 ? item.dictKey == '4' : item.dictKey == '1'"
                    :key="item.dictKey"
                    :label="item.dictKey"
                  >{{
                    item.dictValue
                  }}</el-radio>
                </template>
              </el-radio-group>

                <template v-if="formChild.discountFlag == '1' && formChild.discountType === '4'">
                  <div class="form_item_margin">
                    <el-form-item
                      label="折扣价"
                      prop="basicDiscountPrice"
                    >
                      <div style="display: flex;">
                        <el-input
                          v-model.trim="formChild.basicDiscountPrice"
                          maxlength="20"
                          class="_width_214"
                          placeholder="请输入折扣价"
                          @keypress.native="formatInput"
                          @input="calculateDiscount"
                        ></el-input>
                        <span style="padding-left: 5px;"> 元/台</span>
                      </div>
                    </el-form-item>
                  </div>

                  <!-- 大屏数量购买折扣配置, 企业会员才支持-->
                  <div class="form_item_margin" v-if="formChild.memberTypeKey == 5">
                    <el-form-item
                      label="大屏数量折扣"
                      style="margin-bottom: 15px;"
                    >
                      <el-button
                        type="primary"
                        plain
                        @click="addScreenDiscount"
                      >新增档位</el-button>
                    </el-form-item>
                    <div
                      class="add_screen_discount_box"
                      v-for="(item, index) in formChild.pricingConfig"
                      :key="index"
                    >
                      <el-form-item
                        class="add_screen_discount_item add_screen_discount_item_first"
                        :prop="`pricingConfig.${index}.deviceQtyLimit`"
                        :rules="[{ validator: validatePricingDeviceQtyLimit(item), trigger: 'blur' }]"
                      >
                        <div>购买数量>=</div>
                        <el-input
                          v-model="item.deviceQtyLimit"
                          style="width: 130px; margin: 0 10px;"
                          maxlength="99"
                          placeholder="请输入购买数量"
                          @keypress.native="onKeyPress"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        class="add_screen_discount_item add_screen_discount_item_second"
                        :prop="`pricingConfig.${index}.unitPrice`"
                        :rules="[{ validator: validatePricingUnitPrice(item), trigger: 'blur' }]"
                      >
                        <div>台, 享受</div>
                        <el-input
                          v-model="item.unitPrice"
                          style="width: 130px; margin: 0 10px;"
                          placeholder="请输入折扣价格"
                          @keypress.native="formatInput"
                          @input="calculateDiscount"
                        ></el-input>
                        <div style="margin: 0 10px 0 0;">元/台</div>
                        <div style="color: #999;">折扣比例: {{ item.discountRatio || '-' }}</div>
                        <el-button
                          type="text"
                          icon="el-icon-delete"
                          class="delete_button"
                          @click="removeScreenDiscount(index)"
                        >删除</el-button>
                      </el-form-item>
                    </div>
                  </div>

                  <!-- iOS内购商品展示 -->
                  <div
                    class="form_item_margin"
                    v-if="hasIOSChannel"
                  >
                    <el-form-item label="iOS内购商品">
                      <div class="ios_purchase_box">
                        <div class="ios_purchase_desc">
                          iOS以可提审的价格倒推折扣价格，同时只支持上述档位的加购数量，且单次加购步长为上述档位
                        </div>
                        <div class="ios_purchase_example">
                          举例：最终享受折扣价 138 元，10 台售价=1388，1388 可在苹果商店提审
                        </div>
                        <div class="ios_purchase_items">
                          <div
                            v-for="(item, index) in formChild.pricingConfig"
                            :key="index"
                            class="ios_purchase_item"
                          >
                            档位 {{ index + 1 }}：售价 {{ calculateIOSPrice(item) }} <span v-if="item.saleGoodsId != '0'">（ID: {{ item.saleGoodsId }}）</span>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </template>

                <template v-if="formChild.discountFlag == '1' && formChild.discountType === '1'">
                  <div>
                    <el-button
                      type="primary"
                      plain
                      style="margin-top: 15px;"
                      @click="addTerminalItem"
                    >添加用户标签</el-button>
                  </div>

                  <div
                    style="margin: 15px 0 15px -120px; display: flex; "
                    v-for="(item, index) in formChild.goodsDiscounts"
                    :key="index"
                  >
                    <div style="background-color: #EFF0F3; width: 95%; padding: 15px 15px 0 0;">
                      <el-form-item
                        label="用户标签"
                        :prop="'goodsDiscounts.' + index + '.labelUserTag'"
                        :rules="getHobbyRules('请选择用户标签')"
                      >
                        <el-select
                          v-model="item.labelUserTag"
                          placeholder="请选择用户标签"
                          class="_width_214"
                        >
                          <el-option
                            v-for="item in bizCode.label_user_tag"
                            :key="item.dictKey"
                            :disabled="cleanUpDuplicatesForUser(item.dictKey)"
                            :label="item.dictValue"
                            :value="item.dictKey"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="优惠价"
                        :prop="'goodsDiscounts.' + index + '.labelDiscountPrice'"
                        :rules="getHobbyRules('请输入优惠价')"
                      >
                        <div style="display: flex;">
                          <el-input
                            v-model.trim="item.labelDiscountPrice"
                            class="_width_214"
                            placeholder="请输入优惠价"
                            @keypress.native="formatInput"
                          ></el-input>
                          <span style="padding-left: 5px;"> 元</span>
                        </div>
                      </el-form-item>
                      <el-form-item label="优惠标签">
                        <el-input
                          v-model="item.discountTag"
                          placeholder="请输入优惠标签"
                          class="_width_214"
                          maxlength="20"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="生效时间">
                        <el-date-picker
                          v-model="item.time"
                          type="datetimerange"
                          range-separator="-"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div></div>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #ff0000; margin-left: 10px;"
                      @click="
                    formChild.goodsDiscounts = formChild.goodsDiscounts.filter(
                      i => i !== item
                    )
                    "
                    >删除</el-button>
                  </div>
                </template>
              </el-form-item>
            </div>
          </el-collapse-item>

          <el-collapse-item name="5">
            <template slot="title">
              <div class="_title">
                商品描述配置
                <el-tooltip placement="top">
                  <div slot="content">
                    <ul>
                      <li>优惠标签：商品角标展示，参考图示</li>
                      <li>短、中、长描述：商品的不同文字描述，参考图示</li>
                    </ul>
                  </div>
                  <i class="header-icon el-icon-info"></i>
                </el-tooltip>
              </div>
            </template>
            <div class="_box">
              <div style="display: flex;">
                <div style="width: 70%;">
                  <el-form-item prop="goodsDisplayName" label="商品展示名称">
                    <el-input
                      v-model="formChild.goodsDisplayName"
                      placeholder="请输入商品展示名称"
                      class="_width_214"
                      maxlength="99"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="优惠标签">
                    <el-input
                      v-model="formChild.discountLabel"
                      placeholder="请输入优惠标签"
                      class="_width_214"
                      maxlength="99"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="短描述">
                    <el-input
                      v-model="formChild.shortDescription"
                      placeholder="请输入短描述"
                      class="_width_214"
                      maxlength="99"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="中描述">
                    <el-input
                      v-model="formChild.middleDescription"
                      placeholder="请输入中描述"
                      class="_width_214"
                      maxlength="99"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="长描述">
                    <el-input
                      v-model="formChild.longDescription"
                      placeholder="请输入长描述"
                      class="_width_300"
                      maxlength="9999"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="item_Example">
                  <div class="example_box">
                    <div class="memberBuy_buyList_item active">
                      <div class="content">
                        <div class="day_length">
                          <div class="price">
                            <!-- 推广前缀 -->
                            <span v-if="formChild.presentPriceType != 3 && formChild.presentPriceType != 4">{{
                              formChild.promotePricePrefix }}</span>
                            <!-- 推广价格 -->
                            <span
                              v-if="formChild.presentPriceType != 3 && formChild.presentPriceType != 4"
                              style="font-size: 18px;"
                            >
                              {{ formChild.promotePrice ?
                                '￥' + formChild.promotePrice : '' }} </span>
                            <!-- 推广后缀 -->
                            <span
                              v-if="formChild.presentPriceType != 3 && formChild.presentPriceType != 4"
                              style="font-size: 12px;"
                            >{{
                                formChild.promotePriceSuffix
                              }}</span>
                            <span
                              v-if="formChild.presentPriceType == 4"
                              class="custom_text"
                            >
                              <span class="custom_text_prefix">{{ getCustomText('prefix') }}</span>
                              <span class="custom_text_price">{{ getCustomText('price') }}</span>
                              <span class="custom_text_suffix">{{ getCustomText('suffix') }}</span>
                            </span>
                            <span v-else> {{
                              formChild.paidPricePrefix
                            }} {{
                                formChild.autoRenewFlag == 0
                                  ? '￥' + formChild.salePrice
                                  : '￥' + formChild.firstRenewPrice || "-"
                              }}&nbsp;{{ formChild.paidPriceSuffix }}</span>
                            <!-- {{
                          formChild.autoRenewFlag == 0
                          ? formChild.salePrice
                          : formChild.firstRenewPrice || "-"
                          }}-->

                          </div>
                          <div style="color: #FBDEBE;font-weight: normal; font-size: 14px; display: flex; align-items: center;">
                            <span>
                              {{ formChild.goodsDisplayName || formChild.goodsName || "-" }}
                            </span>
                          </div>
                        </div>

                        <div class="desc">
                          <!-- 实付价 -->
                          <div v-if="formChild.presentPriceType != 3 && formChild.presentPriceType != 4">
                            {{
                              formChild.paidPricePrefix
                            }} {{
                              formChild.autoRenewFlag == 0
                                ? '￥' + formChild.salePrice
                                : '￥' + formChild.firstRenewPrice || "-"
                            }}{{ formChild.paidPriceSuffix }}
                          </div>
                          <div class="desc_txt">
                            <div class="long_desc">
                              {{ formChild.longDescription }}
                            </div>
                            <div class="short_desc">
                              {{ formChild.shortDescription }}
                            </div>
                          </div>
                        </div>
                        <span class="shortDescription">{{
                          formChild.discountLabel
                        }}</span>

                        <div class="firstQuarter_desc">
                          {{ formChild.middleDescription }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <el-form-item label="备注">
                <el-input
                  type="textarea"
                  v-model="formChild.remark"
                  placeholder="请输入备注"
                  rows="4"
                  maxlength="99999"
                ></el-input>
              </el-form-item>
            </div>
          </el-collapse-item>

          <el-collapse-item name="6">
            <template slot="title">
              <div class="_title">
                商品价格呈现
                <el-tooltip placement="top">
                  <div slot="content">
                    <ul>
                      <li>暂无说明</li>
                    </ul>
                  </div>
                  <i class="header-icon el-icon-info"></i>
                </el-tooltip>
              </div>
            </template>
            <div class="_box">
              <div style="display: flex;">
                <div style="width: 80%;">
                  <el-form-item
                    label="商品呈现价格"
                    prop="presentPriceType"
                  >
                    <!-- 单选radio 日均价格 月均价格 商品售价 -->
                    <el-radio-group
                      v-model="formChild.presentPriceType"
                      @change="presentPriceTypeChange"
                    >
                      <el-radio :label="1">日均价格</el-radio>
                      <el-radio :label="2">月均价格</el-radio>
                      <el-radio :label="3">商品售价</el-radio>
                      <el-radio :label="4">自定义文案</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <!-- 选中日均价格显示 -->
                  <div v-if="formChild.presentPriceType === 1">
                    <!-- 推广价格 -->
                    <el-form-item label="推广价格">
                      <div style="display: flex;">
                        <el-input
                          v-model="formChild.promotePricePrefix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                        <div style="padding-left: 5px;;width: 80px;">￥{{ formChild.promotePrice ?
                          formChild.promotePrice : '' }}
                        </div>
                        <!-- <el-input v-model="formChild.promotePrice" maxlength="99" class="_width_114"
                          placeholder="请输入"></el-input> -->
                        <el-input
                          v-model="formChild.promotePriceSuffix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                      </div>
                    </el-form-item>
                    <!-- 实付价格 -->
                    <el-form-item label="实付价格">
                      <div style="display: flex;">
                        <el-input
                          v-model="formChild.paidPricePrefix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                        <div style="padding-left: 5px;;width: 80px;">￥{{ formChild.autoRenewFlag == 0
                          ? formChild.salePrice
                          : formChild.firstRenewPrice || '' }}</div>
                        <!-- <el-input v-model="formChild.promotePrice" maxlength="99" class="_width_114"
                          placeholder="请输入"></el-input> -->
                        <el-input
                          v-model="formChild.paidPriceSuffix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                      </div>
                    </el-form-item>
                  </div>
                  <!-- 选中月均价格显示 -->
                  <div v-if="formChild.presentPriceType === 2">
                    <!-- 推广价格 -->
                    <el-form-item label="推广价格">
                      <div style="display: flex;">
                        <el-input
                          v-model="formChild.promotePricePrefix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                        <div style="padding-left: 5px;;width: 80px;">￥{{ formChild.promotePrice ?
                          formChild.promotePrice : '' }}</div>
                        <!-- <el-input v-model="formChild.promotePrice" maxlength="99" class="_width_114"
                          placeholder="请输入"></el-input> -->
                        <el-input
                          v-model="formChild.promotePriceSuffix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                      </div>
                    </el-form-item>
                    <!-- 实付价格 -->
                    <el-form-item label="实付价格">
                      <div style="display: flex;">
                        <el-input
                          v-model="formChild.paidPricePrefix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                        <div style="padding-left: 5px;;width: 80px;">￥{{ formChild.autoRenewFlag == 0
                          ? formChild.salePrice
                          : formChild.firstRenewPrice }}</div>
                        <el-input
                          v-model="formChild.paidPriceSuffix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                      </div>
                    </el-form-item>
                  </div>
                  <!-- 选中月均价格显示 -->
                  <div v-if="formChild.presentPriceType === 3">
                    <!-- 实付价格 -->
                    <el-form-item label="实付价格">
                      <div style="display: flex;">
                        <el-input
                          v-model="formChild.paidPricePrefix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                        <div style="padding-left: 5px;width: 80px;">￥{{ formChild.autoRenewFlag == 0
                          ? formChild.salePrice
                          : formChild.firstRenewPrice }}</div>
                        <el-input
                          v-model="formChild.paidPriceSuffix"
                          maxlength="99"
                          class="_width_114"
                          placeholder="请输入"
                        ></el-input>
                      </div>
                    </el-form-item>
                  </div>
                  <!-- 选中自定义文案显示 -->
                  <div v-if="formChild.presentPriceType === 4">
                    <el-form-item
                      label="自定义文案"
                      prop="customText"
                    >
                      <el-input
                        v-model="formChild.customText"
                        placeholder="请输入自定义文案"
                        class="_width_370
                        "
                        maxlength="99"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>

            </div>
          </el-collapse-item>
        </el-collapse>

        <el-form-item
          label="商品状态"
          style="margin-top: 15px;"
          prop="state"
        >
          <el-radio-group v-model="formChild.state">
            <el-radio label="1">生效</el-radio>
            <el-radio label="0">失效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div style="text-align: right;">
        <el-button
          size="small"
          @click="$emit('input', false)"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="goodsLocalSave"
        >保存</el-button>
      </div>
    </el-dialog>

    <channel-popups
      v-if="formChild.saleChannelList.length"
      :app-id="formChild.saleChannelList[channelIndex].channelIds"
      :visible.sync="showPopups"
      @comfirm="handleConfirm"
    ></channel-popups>
  </div>
</template>

<script>
import {
  goodsLocalDetailApi,
  goodsLocalSaveApi,
  goodsLocalUpdateApi,
  memberTypeClientsAllApi,
  visiblePhoneExportApi,
  visiblePhoneImportApi,
  visiblePhoneTemplateApi
} from '@/api/goods_manage';
import ChannelPopups from '@/components/channel-popups';
import Message from '@/components/Message';
import axios from 'axios';

/** 可见人群类型 */
const VISIBLE_TYPE = {
  /** 全部用户 */
  ALL: 1,
  /** 用户标签 */
  USER_TAG: 2,
  /** 用户类型 */
  USER_TYPE: 3,
  /** 指定用户（手机号名单） */
  PHONE_LIST: 4
};

const VISIBLE_TYPE_OPTIONS = [
  { value: VISIBLE_TYPE.ALL, label: '全部用户' },
  { value: VISIBLE_TYPE.USER_TAG, label: '用户标签' },
  { value: VISIBLE_TYPE.USER_TYPE, label: '用户类型' },
  { value: VISIBLE_TYPE.PHONE_LIST, label: '指定用户' }
];

/** 手机号名单单次上传条数上限，以服务端校验为准，前端仅用于提示与体验 */
const VISIBLE_PHONE_MAX_COUNT = 100000;
/** 手机号名单文件体积上限(字节)，10万条约 1-2M，留足冗余避免误拦 */
const VISIBLE_PHONE_MAX_FILE_SIZE = 10 * 1024 * 1024;
/** 非法行号最多展示条数，避免整份文件非法时页面被撑爆 */
const INVALID_ROW_DISPLAY_LIMIT = 20;

export default {
  components: {
    ChannelPopups
  },
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
    bizCode: {
      type: Object,
      default: () => {}
    },
    editId: {
      type: String,
      default: ''
    },
    editType: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    isShowAutoRenewFlag() {
      // 商品类型为线上商品时，且会员类型不为企业会员时，显示自动续费商品
      return this.formChild.goodsType == 1 && this.formChild.memberTypeKey != 5;
    },
    hasIOSChannel() {
      // 检查是否有iOS渠道
      let IOSClientTypeId;
      this.bizCode.client_types.forEach((item) => {
        if (item.dictValue == 'IOS手机') {
          IOSClientTypeId = item.dictKey;
        }
      });

      return this.formChild.saleChannelList.some((channel) => channel.clientType === IOSClientTypeId);
    },
    visibleUserTypeOptions() {
      // USER_TYPES 字典里 dictKey 为负数的是分类/标题节点(如 -1 用户类型)，不是真实可选项，
      // 勾选后落库的值服务端永远匹配不上，会导致商品对所有人不可见，故渲染前过滤掉
      const userTypes = this.bizCode.USER_TYPES;
      if (!Array.isArray(userTypes)) {
        return [];
      }
      return userTypes.filter((item) => Number(item.dictKey) > 0);
    }
  },

  data() {
    return {
      client_types_loading: false,
      channelIndex: 0,
      formChild: {
        /** 售价 */
        salePrice: '',
        goodsCode: '',
        saleChannelList: [], // 销售端列表
        goodsDiscounts: [], // 折扣端列表
        frontVisible: '1', //默认是
        autoRenewFlag: '0', // 默认选择否
        salePeriodUnit: '3', // 默认月
        salePeriod: '', // 默认月
        limitPurchaseTimesFlag: '0', //默认选择不限制
        discountFlag: '0', // 默认不设置折扣
        discountType: '1', // 默认基础折扣
        basicDiscountPrice: '', // 基础折扣价格
        pricingConfig: [], // 大屏数量购买折扣列表
        state: '1',
        icon: '1',
        autoRenewPayType: [],
        /** 商品呈现价格 1日均 2月均 3商品售价*/
        presentPriceType: '',
        /** 推广价格 */
        promotePrice: '',
        /** 推广价格前缀 */
        promotePricePrefix: '',
        /** 推广价格后缀 */
        promotePriceSuffix: '',
        /** 实付价格前缀 */
        paidPricePrefix: '',
        /** 实付价格后缀 */
        paidPriceSuffix: '',
        /** 自定义文案 */
        customText: '',
        /** 可见人群类型，默认全部用户 */
        visibleType: VISIBLE_TYPE.ALL,
        /** 可见人群-用户标签，提交时转为逗号分隔字符串 */
        visibleUserTags: [],
        /** 可见人群-用户类型，提交时转为逗号分隔字符串 */
        visibleUserTypes: [],
        /** 可见人群-手机号名单在服务端的存储标识 */
        visiblePhoneKey: '',
        /** 可见人群-手机号名单已导入条数(去重后) */
        visiblePhoneCount: 0
      },
      visibleTypeEnum: VISIBLE_TYPE,
      visibleTypeOptions: VISIBLE_TYPE_OPTIONS,
      visiblePhoneMaxCount: VISIBLE_PHONE_MAX_COUNT,
      /** 名单上传中，防止重复提交 */
      visiblePhoneUploading: false,
      /** 本次上传结果，仅用于展示，不参与提交 */
      visiblePhoneImportResult: null,
      showPopups: false, //渠道组件
      activeNames: ['1', '2', '3', '4', '5', '6'], //折叠面板展开name
      rules: {
        memberTypeId: [{ required: true, message: '请选择会员类型', trigger: 'change' }],
        goodsType: [{ required: true, message: '请选择商品类型', trigger: 'change' }],
        goodsCode: [{ required: true, message: '请输入会员商品编号', trigger: 'blur' }],
        goodsDisplayName: [{ required: true, message: '请输入商品展示名称', trigger: 'blur' }],
        goodsName: [{ required: true, message: '请输入会员商品名称', trigger: 'blur' }],
        frontVisible: [{ required: true, message: '请选择前端可见', trigger: 'blur' }],
        displayOrder: [{ required: true, message: '请输入显示顺序', trigger: 'blur' }],
        autoRenewFlag: [{ required: true, message: '请选择自动续费商品', trigger: 'blur' }],
        salePeriod: [{ required: true, message: '请输入定价周期', trigger: 'change' }],
        salePrice: [{ required: true, message: '请输入售价', trigger: 'blur' }],
        basicDiscountPrice: [{ required: true, message: '请输入折扣价', trigger: 'blur' }],
        limitPurchaseTimesFlag: [{ required: true, message: '请选择限制购买次数', trigger: 'blur' }],
        autoRenewPayType: [
          {
            type: 'array',
            required: true,
            message: '请选择支付方式',
            trigger: 'change'
          }
        ],
        wechatTemplateId: [{ required: true, message: '请输入微信模板ID', trigger: 'blur' }],
        salePeriodUnit: [{ required: true, message: '请选择定价周期', trigger: 'blur' }],
        firstRenewPrice: [{ required: true, message: '请输入首次续费', trigger: 'blur' }],
        followRenewPrice: [{ required: true, message: '请输入后续续费', trigger: 'blur' }],
        discountType: [{ required: true, message: '请选择折扣类型', trigger: 'blur' }],
        state: [{ required: true, message: '请选择商品状态', trigger: 'change' }],
        presentPriceType: [{ required: true, message: '请选择商品呈现价格', trigger: 'change' }],
        customText: [{ required: true, message: '请输入自定义文案', trigger: 'blur' }],
        // 以下三项所在的表单项按可见人群类型 v-if 渲染，未渲染时不会参与校验
        visibleType: [{ required: true, message: '请选择可见人群', trigger: 'change' }],
        visibleUserTags: [{ type: 'array', required: true, message: '请选择用户标签', trigger: 'change' }],
        visibleUserTypes: [{ type: 'array', required: true, message: '请选择用户类型', trigger: 'change' }],
        visiblePhoneCount: [
          {
            validator: (rule, value, callback) => {
              if (Number(value) > 0) {
                callback();
              } else {
                callback(new Error('请上传手机号名单'));
              }
            },
            trigger: 'change'
          }
        ]
      }
    };
  },
  watch: {
    'formChild.autoRenewFlag'(val) {
      this.getPresentPrice();
      if (val == '1') {
        this.formChild.discountFlag = '0';
      }
    }
    /** 定价周期改变，推广价格前缀随之改动 */
  },
  created() {
    this.getDetail().then(() => {
      if (!this.formChild.paidPricePrefix && this.formChild.salePeriodUnit && this.editType !== 'edit') {
        const target = this.bizCode.sale_period_unit.find((item) => item.dictKey == this.formChild.salePeriodUnit);
        this.formChild.paidPricePrefix = '按' + target.dictValue + '支付';
      }
      this.$watch('formChild.salePeriodUnit', {
        handler(val) {
          const target = this.bizCode.sale_period_unit.find((item) => item.dictKey == val);
          if (target) {
            this.formChild.paidPricePrefix = '按' + target.dictValue + '支付';
          }
        }
      });
    });
  },

  methods: {
    /** 自动计算推广价格方法 */
    getPresentPrice() {
      /** 售价/（定价周期*日均值或月均值），日、月、季、年的日均值分别为1、31、93、365，日、月、季、年的月均值分别为1/31、1、3、12 */
      const dayValues = { 1: 1, 2: 31, 3: 93, 4: 365 }; // 日均值权重
      const monthValues = { 1: 1 / 31, 2: 1, 3: 3, 4: 12 }; // 月均值权重

      if (
        (this.formChild.salePrice || this.formChild.firstRenewPrice) &&
        this.formChild.salePeriod &&
        this.formChild.salePeriodUnit &&
        this.formChild.presentPriceType
      ) {
        const { salePrice: price, salePeriod, salePeriodUnit, presentPriceType, autoRenewFlag, firstRenewPrice } = this.formChild;
        const salePrice = autoRenewFlag == 0 ? price : firstRenewPrice;
        // 选择权重映射表
        const weightMap = presentPriceType == 1 ? dayValues : monthValues;

        // 获取对应的权重
        const weight = weightMap[salePeriodUnit];

        if (weight) {
          // 计算 promotePrice 并保留一位小数
          const promotePrice = (salePrice / (salePeriod * weight)).toFixed(1);
          // 返回浮点数
          this.formChild.promotePrice = parseFloat(promotePrice);
          return;
        }
      }

      // 返回默认值
      this.formChild.promotePrice = 0;
      return;
    },
    /** 上传图片校验 */
    checkUpload(file) {
      // 判断类型
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        Message.error('目前只支持jpg/png图片');
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error('不能上传超过5M的图片');
        return false;
      }
    },
    /** 上传图片的方法 */
    async uploadImg(params, key) {
      const file = params.file;
      let formData = new FormData();
      formData.append('file', file);
      try {
        const { data } = await axios.post('/lebo-resource/oss/endpoint/put-file?code=lebotob', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        console.log('上传图片的响应', data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          this.$set(this.formChild, key, result.link);
          /** 提示用户 */
          Message.success('上传成功');
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    // 会员类型跟销售端类型联动
    changeMemberTypeId(val, upData = '') {
      if (val) {
        // 会员类型为企业会员时，不能使用自动续费商品
        this.$set(this.formChild, 'memberTypeKey', this.bizCode.member_type.find((item) => item.dictKey == val).memberTypeKey);
        if (this.formChild.memberTypeKey == 5) {
          this.formChild.autoRenewFlag = '0';
        }

        if (this.client_types_loading) return;
        this.client_types_loading = true;
        memberTypeClientsAllApi().then((res) => {
          this.client_types_loading = false;
          console.log('memberTypeClientsAllApi', res);
          if (Array.isArray(res.data.data) && res.data.data.length) {
            this.bizCode.client_types = res.data.data.map((item) => {
              return {
                dictValue: item.desc,
                dictKey: item.code
              };
            });
            if (!upData) {
              this.formChild.saleChannelList = [];
              // 切换会员类型时，清空折扣相关数据
              this.$set(this.formChild, 'discountFlag', '0');
              this.$set(this.formChild, 'discountType', '');
            }
          } else {
            this.bizCode.client_types = [];
          }
        });
      }
    },
    // 处理是否存在客户端重复
    cleanUpDuplicates(i) {
      // 如果有已经被选择了，return true 把选项禁了
      let is = false;
      this.formChild.saleChannelList.map((item) => {
        if (item.clientType == i) {
          is = true;
        }
      });
      return is;
    },
    // 处理是否存在用户标签重复
    cleanUpDuplicatesForUser(i) {
      // 如果有已经被选择了，return true 把选项禁了
      let is = false;
      this.formChild.goodsDiscounts.map((item) => {
        if (item.labelUserTag == i) {
          is = true;
        }
      });
      return is;
    },
    // 获取详情
    async getDetail() {
      if (this.editId && typeof this.editId === 'string') {
        return goodsLocalDetailApi({ id: this.editId }).then((res) => {
          console.log('goodsLocalDetailApi++', res);

          if (res.data.code == 200) {
            let data = res.data.data;
            // 处理日期格式回显
            if (Array.isArray(data.goodsDiscounts) && data.goodsDiscounts.length) {
              data.goodsDiscounts = data.goodsDiscounts.map((item) => {
                return {
                  ...item,
                  time: [item.startTime, item.endTime]
                };
              });
            }
            // 支付方式处理，转换成array
            if (data.autoRenewPayType) {
              data.autoRenewPayType = data.autoRenewPayType.split(',');
            } else {
              data.autoRenewPayType = [];
            }

            // 可见人群回显：多选值由逗号分隔字符串转成数组，存量商品无配置时按「全部用户」
            data.visibleType = Number(data.visibleType) || VISIBLE_TYPE.ALL;
            data.visibleUserTags = this.splitVisibleValue(data.visibleUserTags);
            data.visibleUserTypes = this.splitVisibleValue(data.visibleUserTypes);
            data.visiblePhoneKey = data.visiblePhoneKey || '';
            data.visiblePhoneCount = Number(data.visiblePhoneCount) || 0;

            this.formChild = data;
            this.formChild.pricingConfig = data.pricingConfig ? JSON.parse(data.pricingConfig) : [];

            // 初始化 销售端类型 回显
            this.$nextTick(() => {
              if (this.formChild.memberTypeId) {
                this.changeMemberTypeId(this.formChild.memberTypeId, 'upData');
              }
            });
          }
        });
      }
    },
    validatePricingDeviceQtyLimit(item) {
      return (rule, value, callback) => {
        if (item.unitPrice && !item.deviceQtyLimit) {
          callback(new Error('请输入购买数量'));
        } else {
          callback();
        }
      }
    },
    validatePricingUnitPrice(item) {
      return (rule, value, callback) => {
        if (item.deviceQtyLimit && !item.unitPrice) {
          callback(new Error('请输入折扣价格'));
        } else {
          callback();
        }
      }
    },
    // 保存
    goodsLocalSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(this.formChild);
          const params = { ...this.formChild };
          // 支付方式处理一下，转换成string
          if (Array.isArray(params.autoRenewPayType) && params.autoRenewPayType.length) {
            params.autoRenewPayType = params.autoRenewPayType.join(',');
          } else {
            params.autoRenewPayType = '';
          }

          // 保存日期处理一下
          if (Array.isArray(params.goodsDiscounts) && params.goodsDiscounts.length) {
            params.goodsDiscounts.forEach((item) => {
              if (Array.isArray(item.time) && item.time.length) {
                item.startTime = item.time[0];
                item.endTime = item.time[1];
              }
            });
          }
          // 如果没有设置折扣，清空一些数据
          if (params.discountFlag == '0') {
            params.discountType = '';
            params.goodsDiscounts = [];
            params.basicDiscountPrice = '';
            params.pricingConfig = '';
          } else if (params.discountType === '4') {
            // 如果是基础折扣,清空用户标签相关数据
            params.goodsDiscounts = [];
            // 处理大屏数量折扣数据，将 pricingConfig 转换为 JSON 字符串
            if (Array.isArray(params.pricingConfig)) {
              // 确保数据中的数值是合法的数字类型
              const cleanPricingConfig = params.pricingConfig.map(item => ({
                deviceQtyLimit: item.deviceQtyLimit ? Number(item.deviceQtyLimit) : '',
                unitPrice: item.unitPrice ? Number(item.unitPrice) : '',
                saleGoodsId: item.saleGoodsId || '0',
                discountRatio: item.discountRatio || ''
              }));
              params.pricingConfig = JSON.stringify(cleanPricingConfig);
            }
          } else if (params.discountType === '1') {
            // 如果是标签折扣,清空基础折扣价格和大屏数量折扣
            params.basicDiscountPrice = '';
            params.pricingConfig = '';
          }

          //销售端列表不可为空

          if (!Array.isArray(params.saleChannelList) || !params.saleChannelList.length || !params.saleChannelList[0].clientType) {
            this.$message.error('销售端类型不可为空！');
            return false;
          }

          // 处理自定义文案
          if (params.presentPriceType != 4) {
            params.customText = '';
          }

          // 可见人群：多选值转逗号分隔字符串，并清空非当前类型的配置
          this.buildVisibleUserParams(params);

          let api = this.editType == 'edit' ? goodsLocalUpdateApi : goodsLocalSaveApi;

          api(params).then((res) => {
            console.log('goodsLocalSaveApi', res);
            if (res.data.code == 200) {
              this.$emit('input', false);
              this.$emit('upData');
            }
          });
        } else {
          Message.error('请检查并完善表单信息');
          return false;
        }
      });
    },
    // 动态校验
    getHobbyRules(msg) {
      return [{ required: true, message: msg, trigger: 'blur' }];
    },
    // 输入范围0-99999，保留两位小数
    formatInput(event) {
      const keyCode = event.keyCode;
      // 只允许输入数字键、小数点、删除键、回车键
      if (keyCode !== 8 && keyCode !== 13 && keyCode !== 46 && (keyCode < 48 || keyCode > 57) && keyCode !== 190) {
        event.preventDefault();
        return;
      }
      // 判断输入的值是否符合要求
      const inputElement = event.target;
      const inputValue = inputElement.value + String.fromCharCode(keyCode);
      if (!/^\d{0,5}(\.\d{0,2})?$/.test(inputValue)) {
        event.preventDefault();
        return;
      }
      if (parseFloat(inputValue) > 99999.99) {
        event.preventDefault();
        return;
      }
    },

    // 添加折扣端
    addTerminalItem() {
      //      - 可添加至多 10 个用户标签
      if (this.formChild.goodsDiscounts.length < 3) {
        this.formChild.goodsDiscounts.push({});
      }
    },
    // 添加销售端
    addTypeItem() {
      this.formChild.saleChannelList.push({
        channelIds: '',
        channelNames: ''
      });
    },
    // 检验限制输入正整数
    onKeyPress(event) {
      const keyCode = event.keyCode;
      // 只允许输入数字键、删除键、回车键
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
        return;
      }
      // 判断输入的值是否为正整数
      const value = event.target.value + String.fromCharCode(keyCode);
      if (!/^\d+$/.test(value)) {
        event.preventDefault();
        return;
      }
    },
    // 选择渠道 赋值
    handleConfirm(data) {
      const { isAll, appId, nameStr } = data;
      this.formChild.saleChannelList[this.channelIndex].channelIds = appId;
      this.formChild.saleChannelList[this.channelIndex].channelNames = nameStr;
      if (isAll) {
        this.formChild.setType = 1;
      }
    },
    // 渠道选择框
    handleClick(i) {
      this.channelIndex = i;
      this.showPopups = true;
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.$emit('input', false);
          this.$refs.form.reset();
          done();
        })
        .catch((_) => {});
    },
    /** 商品描述配置相关 */
    /** 商品呈现价格改变事件 */
    presentPriceTypeChange(val) {
      this.getPresentPrice();
      const presentPriceTypeMap = {
        1: {
          /** 推广后缀 */
          promotePriceSuffix: '每日'
        },
        2: {
          /** 推广后缀 */
          promotePriceSuffix: '每月'
        },
        3: {
          /** 推广后缀 */
          promotePriceSuffix: ''
        },
        4: {
          /** 推广后缀,自定义推广无后缀 */
          promotePriceSuffix: ''
        }
      };
      this.formChild.promotePriceSuffix = presentPriceTypeMap[val].promotePriceSuffix;
    },
    changeGoodsType(val) {
      if (val != 1) {
        this.formChild.autoRenewFlag = '0';
      }
    },
    // 添加大屏数量折扣
    addScreenDiscount() {
      this.formChild.pricingConfig.push({
        deviceQtyLimit: '',
        unitPrice: '',
        saleGoodsId: '0'
      });
    },
    // 删除大屏数量折扣
    removeScreenDiscount(index) {
      this.formChild.pricingConfig.splice(index, 1);
    },
    // 计算折扣比例
    calculateDiscount() {
      if (this.formChild.basicDiscountPrice && this.formChild.pricingConfig.length) {
        //计算所有档位的折扣比例
        this.formChild.pricingConfig.forEach((item) => {
          if (item.unitPrice) {
            const discountRatio = (item.unitPrice / this.formChild.basicDiscountPrice).toFixed(2);
            this.$set(item, 'discountRatio', discountRatio);
          }
        });
      }
    },
    // 计算iOS手机渠道价格
    calculateIOSPrice(item) {
      if (!item || !item.deviceQtyLimit || !item.unitPrice) return '-';
      // 计算iOS价格：数量 * 单价
      const totalPrice = parseFloat((item.deviceQtyLimit * item.unitPrice).toFixed(2));
      return totalPrice;
    },
    /** 可见人群：逗号分隔字符串转数组 */
    splitVisibleValue(value) {
      if (Array.isArray(value)) {
        return value;
      }
      return value ? String(value).split(',') : [];
    },
    /** 可见人群：数组转逗号分隔字符串 */
    joinVisibleValue(value) {
      if (Array.isArray(value)) {
        return value.join(',');
      }
      return value || '';
    },
    /** 可见人群：按当前类型组装提交参数，非当前类型的配置一律置空，避免脏数据入库 */
    buildVisibleUserParams(params) {
      const visibleType = Number(params.visibleType) || VISIBLE_TYPE.ALL;
      params.visibleType = visibleType;
      params.visibleUserTags = visibleType === VISIBLE_TYPE.USER_TAG ? this.joinVisibleValue(params.visibleUserTags) : '';
      params.visibleUserTypes = visibleType === VISIBLE_TYPE.USER_TYPE ? this.joinVisibleValue(params.visibleUserTypes) : '';
      if (visibleType === VISIBLE_TYPE.PHONE_LIST) {
        params.visiblePhoneCount = Number(params.visiblePhoneCount) || 0;
      } else {
        params.visiblePhoneKey = '';
        params.visiblePhoneCount = 0;
      }
    },
    /** 清空已导入的手机号名单（仅清前端引用，服务端旧名单由对账任务回收） */
    resetVisiblePhone() {
      this.$set(this.formChild, 'visiblePhoneKey', '');
      this.$set(this.formChild, 'visiblePhoneCount', 0);
      this.visiblePhoneImportResult = null;
    },
    /** 清空重传 */
    clearVisiblePhone() {
      this.$confirm('确认清空已导入的名单吗？清空后需重新上传。')
        .then(() => {
          this.resetVisiblePhone();
          Message.success('已清空');
        })
        .catch(() => {});
    },
    /** 名单上传前校验：条数上限以服务端为准，此处仅做格式与体积的体验拦截 */
    beforeVisiblePhoneUpload(file) {
      if (!/\.(xlsx|xls)$/i.test(file.name)) {
        Message.error('上传文件只能是 xlsx/xls 格式!');
        return false;
      }
      if (file.size > VISIBLE_PHONE_MAX_FILE_SIZE) {
        Message.error(`文件过大，单次最多上传 ${VISIBLE_PHONE_MAX_COUNT} 条手机号`);
        return false;
      }
      return true;
    },
    /**
     * 导入手机号名单
     * 服务端 GoodsVisiblePhoneImportVO 约定：
     * phoneKey-名单存储标识, totalRows-上传行数, validRows-合法行数, distinctCount-去重后条数,
     * invalidRows-非法行数(计数), invalidRowNumbers-非法行号列表
     */
    importVisiblePhone(params) {
      if (this.visiblePhoneUploading) return;
      this.visiblePhoneUploading = true;

      const formData = new FormData();
      formData.append('file', params.file);
      if (this.editId) {
        formData.append('goodsId', this.editId);
      }

      visiblePhoneImportApi(formData)
        .then((res) => {
          console.log('visiblePhoneImportApi', res);
          if (res.data.code != 200) return;

          const result = res.data.data || {};
          const distinctCount = Number(result.distinctCount) || 0;
          if (distinctCount <= 0) {
            Message.error('名单中没有合法的手机号，请检查文件内容');
            this.visiblePhoneImportResult = this.buildImportResult(result);
            return;
          }

          this.$set(this.formChild, 'visiblePhoneKey', result.phoneKey || '');
          this.$set(this.formChild, 'visiblePhoneCount', distinctCount);
          this.visiblePhoneImportResult = this.buildImportResult(result);
          this.$refs.form.clearValidate(['visiblePhoneCount']);
          Message.success(`导入成功，已导入 ${distinctCount} 条`);
        })
        .finally(() => {
          this.visiblePhoneUploading = false;
        });
    },
    /** 组装导入结果展示文案，非法行号超过展示上限时只展示前若干条 */
    buildImportResult(result) {
      return {
        totalRows: Number(result.totalRows) || 0,
        validRows: Number(result.validRows) || 0,
        distinctCount: Number(result.distinctCount) || 0,
        invalidRowText: this.buildInvalidRowText(result)
      };
    },
    /**
     * 非法行文案
     * invalidRows 是服务端给的非法行「计数」，invalidRowNumbers 才是行号列表，
     * 行号列表可能已被服务端截断，故总数一律以 invalidRows 为准
     */
    buildInvalidRowText(result) {
      const invalidRowCount = Number(result.invalidRows) || 0;
      if (invalidRowCount <= 0) {
        return '';
      }
      const rowNumbers = Array.isArray(result.invalidRowNumbers) ? result.invalidRowNumbers : [];
      const shownRows = rowNumbers.slice(0, INVALID_ROW_DISPLAY_LIMIT);
      if (!shownRows.length) {
        return `共 ${invalidRowCount} 行非法`;
      }
      if (invalidRowCount > shownRows.length) {
        return `${shownRows.join('、')} 等，共 ${invalidRowCount} 行非法`;
      }
      return shownRows.join('、');
    },
    /** 下载手机号名单模板 */
    downloadVisiblePhoneTemplate() {
      visiblePhoneTemplateApi().then((res) => {
        this.saveExcelFile(res.data, '可见人群手机号模板.xlsx');
      });
    },
    /** 下载已导入的手机号名单 */
    downloadVisiblePhone() {
      const fileName = this.formChild.goodsCode ? `可见人群手机号名单_${this.formChild.goodsCode}.xlsx` : '可见人群手机号名单.xlsx';
      visiblePhoneExportApi({ id: this.editId, phoneKey: this.formChild.visiblePhoneKey }).then((res) => {
        this.saveExcelFile(res.data, fileName);
      });
    },
    /** 将二进制响应存为本地文件 */
    saveExcelFile(fileData, fileName) {
      const url = window.URL.createObjectURL(new Blob([fileData]));
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    getCustomText(type) {
      if (this.formChild.customText == '') {
        return '';
      }

      const customTextPrefix = this.formChild.customText.split('￥')[0];

      let customTextPrice = '';
      let customTextSuffix = '';

      if (this.formChild.customText.split('￥').length >= 2 && this.formChild.customText.split('￥')[1].match(/\d+/)) {
        // ￥后面的数字
        customTextPrice = this.formChild.customText.split('￥')[1].match(/\d+/)[0];

        // 拿到数字后面的字符串
        this.formChild.customText.split('￥').forEach((item, index) => {
          if (index === 0) {
            customTextSuffix += '';
          } else if (index === 1) {
            customTextSuffix += item.replace(/\d+/, '');
          } else {
            customTextSuffix += '￥' + item;
          }
        });
      }

      if (type === 'prefix') {
        return this.formChild.customText.split('￥').length >= 2 ? customTextPrefix + '￥' : customTextPrefix;
      } else if (type === 'price') {
        return customTextPrice;
      } else if (type === 'suffix') {
        return customTextSuffix;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.el-collapse-item__header {
  border: none;
}

::v-deep.el-collapse {
  border: none;
}

::v-deep.el-collapse-item__wrap {
  border: none;
}

._width_114 {
  width: 214px;
}

._width_214 {
  width: 214px;
}

._width_300 {
  width: 300px;
}

._width_370 {
  width: 370px;
}

._width_609 {
  width: 609px;
}

._title {
  font-size: 16px;
}

.form_item_margin {
  margin: 15px 0 15px -120px;
}

._box {
  background-color: #f7f7f7;
  padding: 20px 40px;
  border-radius: 2px;
}

.item_Example {
  .example_box {
    margin-left: 0px;
  }
}

.memberBuy_buyList_item {
  padding: 16px 15px 0;

  .content {
    width: 340px;
    height: 110px;
    box-sizing: border-box;
    padding: 1px 0px 0px;
    text-align: center;
    position: relative;
    color: #020100;
    background: #000 !important;
    border-radius: 20px;
    box-shadow: 1px 1px 6px rgba(255, 216, 142, 0.2);

    .shortDescription {
      position: absolute;
      top: -12px;
      right: -2px;
      background: linear-gradient(90deg, #ff8324 1.01%, #fe614a 100%);
      border-radius: 10px 10px 10px 0px;
      padding: 4px 12px 3px 17px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      color: #fff;
      line-height: 17px;
    }

    .day_length {
      margin-top: 15px;
      margin-right: 20px;
      display: flex;
      justify-content: space-between;
      color: #1e1e21;
      text-align: center;
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
    }

    .title {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      font-size: 16px;
      font-weight: 500;
      line-height: 22.5px;
      margin-bottom: 6px;
    }

    .price {
      margin-left: 20px;
      font-size: 16px;
      font-family: 'DIN';
      position: relative;
      font-weight: 500;
      color: #fbdebe;

      span {
        font-size: 14px;
      }

      .custom_text {
        .custom_text_price {
          font-size: 20px;
        }
      }
    }

    .desc {
      margin-left: 20px;
      display: flex;
      font-size: 12px;
      line-height: 17px;
      color: #a5947f;
      .desc_txt {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        .short_desc {
          width: 90px;
        }
        .long_desc {
          font-size: 14px;
          flex: 1;
          text-align: left;
        }
      }
    }

    .firstQuarter_desc {
      margin-top: 10px;
      margin-left: 20px;
      display: flex;
      font-size: 12px;
      font-weight: 500;
      color: #a5947f;
    }

    .firstQuarter {
      width: 32px;
      height: 18px;
      position: absolute !important;
      display: block !important;
      text-align: center !important;
      background: linear-gradient(90deg, #ff6a4d 0%, #ff291f 100%) !important;
      border-radius: 4px 4px 0px 4px !important;
      left: 5px !important;
      top: 5px !important;
      font-size: 12px !important;
      color: #fff !important;
      line-height: 18px !important;
      font-weight: 400 !important;
    }

    .label {
      position: absolute;
      right: -1px;
      top: -12px;
      width: 64px;
      line-height: 24px;
      font-size: 13px;
      color: #885a01;
      font-family: 'PingFang SC';
      font-style: normal;
      display: block;
      padding: 0 7px;
      height: 24px;
      text-align: center;
      background: linear-gradient(251.28deg, #fff1d0 3.39%, #ffd99b 93.42%);
      border-radius: 0px 10px;
      // background-image: url('~@/assets/images/mapp/Rectangle12@2x.png');
    }
  }

  &.active .content {
    // background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 249, 239, 0) 100%);
    // border-radius: 16px;
    // border: 2.5px solid #f2791f;
    background: rgba(248, 104, 4, 0.1);
  }

  i {
    font-style: normal;
  }
}

.avatar-uploader,
.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.image-container {
  position: relative;
  width: 200px;
}

.image {
  width: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-container:hover .overlay {
  opacity: 1;
}

.delete-button {
  font-size: 32px;
  color: #fff;
  cursor: pointer;
}

.add_screen_discount_box {
  background-color: #e3e3e3;
  padding: 15px;
  margin-left: 120px;
  margin-bottom: 10px;
  border-radius: 4px;
  /deep/ .add_screen_discount_item {
    margin-bottom: 0;
    display: inline-block;
    .el-form-item__content {
      display: flex;
      align-items: center;
      position: relative;
      .delete_button {
        position: absolute;
        right: -50px;
        top: 0;
        color: #ff4d4f;
        margin-left: 10px;
      }
    }
  }
  /deep/ .add_screen_discount_item_first {
    .el-form-item__error {
      left: 100px;
    }
  }
  /deep/ .add_screen_discount_item_second {
    .el-form-item__error {
      left: 75px;
    }
  }
}

.visible_phone_actions {
  display: flex;
  align-items: center;

  .visible_phone_upload {
    margin: 0 10px;
    // 覆盖本文件中 .el-upload 的虚线框，避免按钮被套上传图片的样式
    /deep/ .el-upload {
      border: none;
      border-radius: 0;
    }
  }
}

.visible_phone_tip {
  color: #999;
  font-size: 12px;
  line-height: 20px;
}

.visible_phone_result {
  color: #666;
  font-size: 12px;
  line-height: 20px;

  .visible_phone_invalid {
    color: #ff4d4f;
    word-break: break-all;
  }
}

.ios_purchase_box {
  background-color: #e3e3e3;
  padding: 5px 15px;
  border-radius: 4px;

  .ios_purchase_desc {
    color: #666;
    font-size: 14px;
  }

  .ios_purchase_example {
    color: #666;
    font-size: 14px;
    margin-bottom: 15px;
  }

  .ios_purchase_items {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .ios_purchase_item {
      background-color: #a9c8ec;
      padding: 8px 15px;
      border-radius: 4px;
      color: #f5f5f5;
      font-size: 14px;
    }
  }
}
</style>
